// extracted by mini-css-extract-plugin
export default {"title_container":"TocWorkspaceBlock_title_container__vNe8P"};